import { withDependencies, named } from '@wix/thunderbolt-ioc'
import { SiteFeatureConfigSymbol, MasterPageFeatureConfigSymbol } from '@wix/thunderbolt-symbols'
import { getUrlPageId } from '@wix/url-mapper-utils'
import type { CustomUrlMapperSiteConfig, CustomUrlMapperMasterPageConfig, ICustomUrlMapper } from './types'
import { name } from './symbols'

const customUrlMapperFactory = (
	{ urlMappings }: CustomUrlMapperSiteConfig,
	masterPageConfig: CustomUrlMapperMasterPageConfig
): ICustomUrlMapper => {
	return {
		urlMappings,
		getUrlPageRoute(routes, url = '') {
			const { appPageIds } = masterPageConfig
			const resolvedPageId = getUrlPageId(urlMappings, appPageIds, url)
			return Object.keys(routes).find((key: string) => routes[key].pageId === resolvedPageId)
		},
	}
}

export const CustomUrlMapper = withDependencies(
	[named(SiteFeatureConfigSymbol, name), named(MasterPageFeatureConfigSymbol, name)],
	customUrlMapperFactory
)
